import * as React from "react";

const ArrowRightUp = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
    className={className}
  >
    <g
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_3515_9103)"
    >
      <path d="m4.5 12 8-8M6 4h6.5v6.5"></path>
    </g>
    <defs>
      <clipPath id="clip0_3515_9103">
        <path fill="#fff" d="M.5 0h16v16H.5z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ArrowRightUp;
